const essentialDetails = [
  {
    name: 'Property Type',
    valuePath: 'property_type',
  },
  {
    name: 'Property Sub Type',
    valuePath: 'property_sub_type',
  },
  {
    name: 'Status',
    valuePath: 'listing.mls_status',
  },
  {
    name: { valuePath: 'structure.living_area_units' },
    thousandSeparator: true,
    valuePath: 'structure.living_area',
  },
  {
    name: 'Bedrooms',
    valuePath: 'structure.bedrooms_total',
  },
  {
    name: 'MLS#',
    valuePath: 'listing.listing_id',
  },
  {
    name: 'BATHROOMS (FULL)',
    valuePath: 'structure.bathrooms_full',
  },
  {
    name: 'BATHROOMS(3/4)',
    valuePath: 'structure.bathrooms_three_quarter',
  },
  {
    name: 'BATHROOMS(HALF)',
    valuePath: 'structure.bathrooms_half',
  },
];

const interiorDetails = [
  {
    name: 'FLOORING',
    separateCommas: true,
    valuePath: 'structure.flooring',
  },
  {
    name: 'BATH FEATURES',
    separateCommas: true,
    valuePath: 'characteristics.spa_features',
  },
  {

    name: 'APPLIANCES',
    separateCommas: true,
    valuePath: 'equipment.appliances',
  },
  {
    name: 'LAUNDRY FEATURES',
    separateCommas: true,
    valuePath: 'characteristics.laundry_features',
  },
  {

    name: 'INTERIOR FEATURES',
    separateCommas: true,
    valuePath: 'structure.interior_features',
  },
  {

    name: 'FIREPLACE FEATURES',
    separateCommas: true,
    valuePath: 'structure.fireplace_features',
  },
  {
    name: 'SECURITY FEATURES',
    separateCommas: true,
    valuePath: 'equipment.security_features',
  },

];

const utilityDetails = [
  {
    name: 'HEATING',
    separateCommas: true,
    valuePath: 'structure.heating',
  },
  {
    name: 'IRRIGATION SOURCE',
    separateCommas: true,
    valuePath: 'utility.irrigation_source',
  },
  {
    name: 'COOLING',
    separateCommas: true,
    valuePath: 'structure.cooling',
  },
  {
    name: 'IRRIGATION WATER RIGHTS',
    valuePath: 'utility.irrigation_water_rights_y_n',
  },
  {
    name: 'ELECTRIC',
    separateCommas: true,
    valuePath: 'utility.electric',
  },
  {
    name: 'SEWER',
    separateCommas: true,
    valuePath: 'utility.sewer',
  },
  {
    name: 'UTILITY FEATURES',
    separateCommas: true,
    valuePath: 'utility.utilities',
  },
  {
    name: 'WATER SOURCE',
    separateCommas: true,
    valuePath: 'utility.water_source',
  },
];

const constructionDetails = [
  {
    name: 'YEAR BUILT',
    valuePath: 'structure.year_built',
  },
  {
    name: 'NEW CONSTRUCTION',
    valuePath: 'structure.new_construction_y_n',
  },
  {
    name: 'BUILDER NAME',
    valuePath: 'structure.builder_name',
  },
  {
    name: 'FOUNDATION',
    valuePath: 'structure.foundation_details',
  },
  {
    name: 'BASEMENT',
    valuePath: 'structure.basement',
  },
  {
    name: 'ACCESSIBILITY FEATURES',
    valuePath: 'structure.accessibility_features',
  },
  {
    name: 'FINISHED BASEMENT SIZE',
    merge: {

      separator: ' ',
      details: [
        {
          valuePath: 'structure.below_grade_finished_area',
          thousandSeparator: true,
        },
        {
          valuePath: 'structure.below_grade_finished_area_units',
        },
      ],
    },
  },
  {
    name: 'BUILDING FEATURES',
    valuePath: 'structure.building_features',
  },
];

const exteriorDetails = [
  {
    name: 'ARCHITECTURAL STYLE',
    valuePath: 'structure.architectural_style',
  },
  {

    name: 'FENCE',
    valuePath: 'characteristics.fencing',
  },
  {

    name: 'ROOF',
    valuePath: 'structure.roof',
  },
  {
    name: 'LOT SIZE',
    merge: {
      separator: ' ',
      details: [
        {
          valuePath: 'characteristics.lot_size_area',
          decimalPlaces: 2,
        },
        {
          valuePath: 'characteristics.lot_size_units',
        },
      ],
    },
  },
  {
    name: 'LOT FEATURES',
    valuePath: 'characteristics.lot_features',
  },
  {
    name: 'EXTERIOR FEATURES',
    valuePath: 'structure.exterior_features',
  },
  {
    name: 'PRIVATE POOL',
    booleanToYesNo: true,
    valuePath: 'characteristics.pool_private_y_n',
  },
  {
    name: 'POOL FEATURES',
    valuePath: 'characteristics.pool_features',
  },
  {
    name: 'PARKING SPACES',
    valuePath: 'structure.parking_total',
    decimalPlaces: 0,
  },
  {
    name: 'GARAGE SPACES',
    valuePath: 'structure.garage_spaces',
    decimalPlaces: 0,
  },
  {
    name: 'PARKING FEATURES',
    valuePath: 'structure.parking_features',
  },
  {
    name: 'VIEW',
    valuePath: 'characteristics.view',
  },
];
const locationDetails = [
  {
    name: 'CITY',
    valuePath: 'location.address.city',
  },
  {
    name: 'SUBDIVISION',
    valuePath: 'location.area.subdivision_name',
  },
  {
    name: 'COUNTY',
    valuePath: 'location.address.county_or_parish',
  },
  {
    name: 'AREA',
    valuePath: 'location.area.mls_area_major',
  },
  {
    name: 'STATE',
    valuePath: 'location.address.state_or_province',
  },
  {
    name: 'SUB AREA',
    valuePath: 'location.area.mls_area_minor',
  },
  {
    name: 'LOCATION FEATURES',
    merge: {
      separator: '\n',
      details: [
        {
          valuePath: 'characteristics.frontage_length',
        },
        {
          valuePath: 'characteristics.frontage_type',
        },
      ],
    },
  },
  {
    name: 'SENIOR COMMUNITY',
    valuePath: 'characteristics.senior_community_y_n',
    booleanToYesNo: true,
  },
  {
    name: 'ZONING',
    merge: {
      separator: '\n',
      details: [
        {
          valuePath: 'tax.zoning',
        },
        {
          valuePath: 'tax.zoning_description',
        },
      ],
    },

  },
  {
    name: 'COMMUNITY FEATURES',
    valuePath: 'characteristics.community_features',
    separateCommas: true,
  },
];

const schoolDetails = [
  {
    name: 'ELEMENTARY SCHOOL',
    valuePath: 'location.school.elementary_school',
  },
  {
    name: 'ELEMENTARY SCHOOL DISTRICT',
    valuePath: 'location.school.elementary_school_district',
  },
  {
    name: 'MIDDLE SCHOOL',
    valuePath: 'location.school.middle_or_junior_school',
  },
  {
    name: 'MIDDLE SCHOOL DISTRICT',
    valuePath: 'location.school.middle_or_junior_school_district',
  },
  {
    name: 'HIGH SCHOOL',
    valuePath: 'location.school.high_school',
  },
  {
    name: 'HIGH SCHOOL DISTRICT',
    valuePath: 'location.school.high_school_district',
  },
];

const financialDetails = [
  {
    name: 'HOA',
    valuePath: 'hoa.association_y_n',
    booleanToYesNo: true,
  },
  {
    name: 'TAX AMOUNT',
    valuePath: 'tax.tax_annual_amount',
    dollarFormat: {
      decimalPlaces: 0,
    },
  },
  {
    name: 'HOA FEE',
    valuePath: 'hoa.association_fee',
    dollarFormat: true,
  },
  {
    name: 'TAX YEAR',
    valuePath: 'tax.tax_year',
  },
  {
    name: 'HOA FREQUENCY',
    valuePath: 'hoa.association_fee_frequency',
  },
  {
    name: 'HOA AMENITIES',
    valuePath: 'hoa.association_amenities',
    separateCommas: true,
  },
];

const dateDetails = [
  {
    name: 'LISTED',
    valuePath: 'listing.dates.on_market_date',
    dateFormat: 'MM/dd/yyyy',
  },
  {
    name: 'SOLD',
    valuePath: 'listing.dates.close_date',
    dateFormat: 'MM/dd/yyyy',
  },
  {
    name: 'LATEST UPDATE',
    valuePath: 'updated_at',
    dateFormat: 'MM/dd/yyyy',
  },
  {
    name: 'DAYS ON MARKET',
    valuePath: 'listing.dates.days_on_market',
  },
  {
    name: 'PRICE CHANGE(S)',
    valuePath: 'listing.price.list_price_snapshots',
    separator: '\n',
    limit: 5,
    changesOn: {
      valuePath: 'list_price',
    },
    arrayFormat: {
      merge: {
        separator: ' ',
        details: [
          {
            valuePath: 'list_price',
            dollarFormat: {
              decimalPlaces: 0,
            },
          },
          {
            valuePath: 'modification_timestamp',
            dateFormat: 'LLL dd, yyyy',
          },
        ],
      },
    },
  },
  {
    name: 'CUMULATIVE DAYS ON MARKET',
    valuePath: 'listing.dates.cumulative_days_on_market',
  },
];

export default [
  {
    title: 'Essential',
    key: 'essentials',
    content: essentialDetails,
  },
  {
    title: 'Interior',
    key: 'interior',
    content: interiorDetails,
  },
  {
    title: 'Utilities',
    key: 'utilities',
    content: utilityDetails,
  },
  {
    title: 'Construction',
    key: 'construction',
    content: constructionDetails,
  },
  {
    title: 'Exterior',
    key: 'exterior',
    content: exteriorDetails,
  },
  {
    title: 'Location',
    key: 'location',
    content: locationDetails,
  },
  {
    title: 'Schools',
    key: 'shcools',
    content: schoolDetails,
  },
  {
    title: 'Financial',
    key: 'financial',
    content: financialDetails,
  },
  {
    title: 'Dates',
    key: 'dates',
    content: dateDetails,
  },
];
